<div class="ibox detailed-view-ibox" *ngIf="settingsSmsService.showDetailedView">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">SMS Settings</div>
        <div style="font-size: 15px;">
            {{settingsSmsService.selectedItemData ? settingsSmsService.selectedItemData.corporationNumberName : ''}}
        </div>
        <span class="close-detailed-view" (click)="settingsSmsService.toggleDetailedView(null, false)">×</span>
    </div>
    <div>
        <div class="detailed-view-body">
            <div class="detailed-view__more-info m-t-md" *ngIf="settingsSmsService.selectedItemData">
                <form #form="ngForm" submittable autocomplete="off">
                    <div class="general-tab">
                        <div class="text-center">
                            <button class="btn btn-primary install-uninstall-button m-b-lg"
                                    [disabled]="noEdit"
                                    (click)="installSmsNotifications()"
                                    *ngIf="!settingsSmsService.selectedItemData.twilioSettings?.sid &&
                                           !settingsSmsService.selectedItemData.twilioSettings?.friendlyName">
                                Install
                            </button>
                        </div>

                        <div class="settings-amenities-slider-container">
                            <span>Service is Enabled</span>
                            <mat-slide-toggle name="isEnable"
                                              [disabled]="noEdit"
                                              (change)="changeEnableStatus(form.value.isEnable)"
                                              [ngModel]="settingsSmsService.selectedItemData.isEnable">
                            </mat-slide-toggle>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-md-6 bold">Assigned Phone Number:</div>
                            <div class="col-md-6 text-right"
                                 *ngIf="settingsSmsService.selectedItemData.twilioSettings?.activePhones.length > 0">
                                <span *ngFor="let phone of settingsSmsService.selectedItemData.twilioSettings.activePhones; let last = last;">
                                    {{phone}}{{!last ? ', ' : ''}}
                                </span>
                            </div>
                            <div class="col-md-6 text-right"
                                 *ngIf="settingsSmsService.selectedItemData.twilioSettings?.activePhones.length < 1">
                                -
                            </div>
                        </div>

                        <div class="text-center m-t-lg">
                            <button class="btn btn-primary install-uninstall-button"
                                    [disabled]="noEdit"
                                    (click)="uninstallSmsNotifications()"
                                    *ngIf="accountService.isUserAdmin() &&
                                           settingsSmsService.selectedItemData.twilioSettings?.sid &&
                                           settingsSmsService.selectedItemData.twilioSettings?.friendlyName">
                                Uninstall
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div *ngIf="!settingsSmsService.selectedItemData">
                <spinner [spinnerShow]="true"></spinner>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-sms/settings-sms-detailed-view/settings-sms-detailed-view.component.html